import { Component, inject, input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';

import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { WebchatLearnMoreComponent } from '../webchat-learn-more/webchat-learn-more.component';
import { Widget } from '../webchat-form/widget';
import { InboxAiBadgeComponent } from '../../../inbox-ai/inbox-ai-badge/inbox-ai-badge.component';
import { InboxService } from '../../../../../core/src/index';

const WEBCHAT_ICON = 'https://vstatic-prod.apigateway.co/business-center-client/assets/webchat-icon.svg';

type BadgeState = {
  color: 'red' | 'green' | 'grey';
  name: string;
};

@Component({
  selector: 'inbox-webchat-config-card',
  templateUrl: './webchat-config-card.component.html',
  styleUrls: ['./webchat-config-card.component.scss'],
  imports: [
    MatCardModule,
    MatListModule,
    GalaxyBadgeModule,
    MatButtonModule,
    TranslateModule,
    InboxAiBadgeComponent,
    RouterLink,
  ],
})
export class WebchatConfigCardComponent {
  readonly webchats = input.required<Widget[]>();
  readonly canShowMyListingsCTA = input<boolean>(false);
  readonly showCreateWebChatCTA = input<boolean>(false);
  readonly showWebChatUpgradeModal = input<boolean>(false);
  readonly goToMyListingUrl = input<string>('');

  protected readonly webchatIcon = WEBCHAT_ICON;

  private readonly inboxService = inject(InboxService);
  protected readonly isPartnerCenter = this.inboxService.isPartnerCenter;
  private readonly dialog = inject(MatDialog);
  private readonly router = inject(Router);
  protected readonly route = inject(ActivatedRoute);
  protected learnMore(): void {
    this.dialog.open(WebchatLearnMoreComponent, {
      width: '660px',
    });
  }

  protected badgeState(widget?: Widget, listingUrl?: string): BadgeState {
    if (widget?.isEnabled) {
      return { color: 'green', name: 'INBOX.SETTINGS.ACTIVE' };
    }
    if (widget) {
      return { color: 'grey', name: 'INBOX.WEBCHAT.SETTINGS.NOT_ACTIVE' };
    }
    // inbox pro widget not created
    if (!widget && !listingUrl) {
      return { color: 'red', name: 'INBOX.WEBCHAT.SETTINGS.SETUP_REQUIRED' };
    }
    // not enabled, not created, and going to my listing CTA
    return { color: 'grey', name: 'INBOX.WEBCHAT.SETTINGS.NOT_ACTIVE' };
  }

  protected webChatCardRedirectMyListing(widget?: Widget): void {
    this.navigateToMyListing(widget?.myListingUrl || this.goToMyListingUrl());
  }

  private navigateToMyListing(listingUrl: string): void {
    window.open(listingUrl, '_blank');
  }
}
